import pkg from "../../package.json";

export default {
  API_URL: "http://app.deepseq.ai:8000",
  //API_URL: "http://ec2-35-166-249-181.us-west-2.compute.amazonaws.com:8000",
  URL: "https://www.deepseq.ai/",
  MAIL_ADDRESS: "info@deepseq.ai",
  GA_ACCOUNT: "UA-152882062-1",
  TIMEOUT: 60 * 1000,
  DEFAULT_LOCALE: "en",
  VERSION: pkg.version,
  BUILD: "{build number}",
};
